var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content cross-delegation-markup-rule" },
          [
            _c("div", { staticClass: "app-main-inner-row" }, [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "80px",
                        "label-position": "left"
                      },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w320",
                              attrs: { label: "委托方" }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Office_NoHQ,
                                  "method-params": {},
                                  filterable: "",
                                  "default-value": _vm.filter.delegatorCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.filter.delegatorCode = p.code
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w320",
                              attrs: { label: "被委托方" }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Office_NoHQ,
                                  "method-params": {},
                                  filterable: "",
                                  "default-value": _vm.filter.delegateeCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.filter.delegateeCode = p.code
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.toQuery }
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.toCreate }
                            },
                            [_vm._v("新增")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.toCopy }
                            },
                            [_vm._v("复制")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { ref: "gridWrapper", staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "261607",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "side-bar": _vm.sideBarDefs
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    selectionChanged: _vm.onSelectionChanged,
                    cellClicked: _vm.onCellClicked
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "261607",
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.showDetail,
            title: _vm.dialogTitle,
            width: "1000px",
            "custom-class": "cross-delegation-markup-rule-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.showDetail = $event
            },
            close: _vm.onCancel
          }
        },
        [
          _c("div", { staticClass: "details-view" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w400",
                              attrs: { label: "委托方", prop: "delegatorCode" }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Office_NoHQ,
                                  "method-params": {},
                                  filterable: "",
                                  disabled: _vm.isEditMode || _vm.isDetailMode,
                                  "default-value": _vm.form.delegatorCode,
                                  placeholder: "请选择"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.delegatorCode = p.code
                                    _vm.form.delegatorName =
                                      p.chineseName ||
                                      p.englishName ||
                                      p.label ||
                                      ""
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w400",
                              attrs: {
                                label: "被委托方",
                                prop: "delegateeCode"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Office_NoHQ,
                                  "method-params": {},
                                  filterable: "",
                                  disabled: _vm.isEditMode || _vm.isDetailMode,
                                  "default-value": _vm.form.delegateeCode,
                                  placeholder: "请选择"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.delegateeCode = p.code
                                    _vm.form.delegateeName =
                                      p.chineseName ||
                                      p.englishName ||
                                      p.label ||
                                      ""
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "fee-section" },
                [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c("span", { staticClass: "section-title" }, [
                        _vm._v("费用维度")
                      ]),
                      !_vm.isDetailMode
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-plus"
                              },
                              on: { click: _vm.addFeeRow }
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.form.feeList,
                        border: "",
                        stripe: "",
                        "max-height": "200"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "费用名称", "min-width": "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_ChargeItem,
                                    "method-params": {},
                                    filterable: "",
                                    disabled: _vm.isDetailMode,
                                    "default-value": scope.row.feeId,
                                    placeholder: "请选择"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      scope.row.feeId = p.value || p.itemId
                                      scope.row.feeName =
                                        p.zhName || p.enName || p.label || ""
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "加价幅度（单价）", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input-number", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    precision: 2,
                                    step: 1,
                                    min: 0,
                                    disabled: _vm.isDetailMode,
                                    size: "small"
                                  },
                                  model: {
                                    value: scope.row.markupAmount,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "markupAmount", $$v)
                                    },
                                    expression: "scope.row.markupAmount"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      !_vm.isDetailMode
                        ? _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "80",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          type: "danger",
                                          icon: "el-icon-delete",
                                          circle: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteFeeRow(
                                              scope.$index
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2889414786
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "job-section" },
                [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c("span", { staticClass: "section-title" }, [
                        _vm._v("订单维度")
                      ]),
                      !_vm.isDetailMode
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-plus"
                              },
                              on: { click: _vm.addJobRow }
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.form.jobList,
                        border: "",
                        stripe: "",
                        "max-height": "300"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "业务类型", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isDetailMode,
                                      size: "small",
                                      placeholder: "请选择"
                                    },
                                    on: {
                                      change: function(val) {
                                        return _vm.onBusinessTypeChange(
                                          scope.row,
                                          val
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.businessType,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "businessType", $$v)
                                      },
                                      expression: "scope.row.businessType"
                                    }
                                  },
                                  _vm._l(_vm.businessTypeOptions, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "整拼类型", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDetailMode ||
                                        !_vm.isContainerLoadTypeEditable(
                                          scope.row.businessType
                                        ),
                                      clearable: "",
                                      size: "small",
                                      placeholder: "请选择"
                                    },
                                    on: {
                                      change: function(val) {
                                        return _vm.onContainerLoadTypeChange(
                                          scope.row,
                                          val
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.containerLoadType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "containerLoadType",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.containerLoadType"
                                    }
                                  },
                                  _vm._l(
                                    _vm.getContainerLoadTypes(
                                      scope.row.businessType
                                    ),
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "加价单位", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isDetailMode,
                                      clearable: "",
                                      size: "small",
                                      placeholder: "请选择"
                                    },
                                    on: {
                                      change: function(val) {
                                        return _vm.onMarkupUnitChange(
                                          scope.row,
                                          val
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.markupUnit,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "markupUnit", $$v)
                                      },
                                      expression: "scope.row.markupUnit"
                                    }
                                  },
                                  _vm._l(_vm.markupUnitOptions, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "箱型", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDetailMode ||
                                        scope.row.markupUnit !== "EQ_TYPE",
                                      clearable: "",
                                      size: "small",
                                      placeholder: "请选择"
                                    },
                                    model: {
                                      value: scope.row.eqType,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "eqType", $$v)
                                      },
                                      expression: "scope.row.eqType"
                                    }
                                  },
                                  _vm._l(_vm.eqTypeOptions, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "箱种", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_EQType,
                                    "method-params": {},
                                    fields: ["code"],
                                    filterable: "",
                                    disabled:
                                      _vm.isDetailMode ||
                                      scope.row.markupUnit !== "EQ_TYPE",
                                    "default-value": scope.row.eqKind,
                                    "tag-name": "code",
                                    "tag-value": "code",
                                    placeholder: "请选择"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      scope.row.eqKind = p.code
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "币种", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Currency,
                                    "method-params": {},
                                    filterable: "",
                                    disabled: _vm.isDetailMode,
                                    "default-value": scope.row.currency,
                                    placeholder: "请选择"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      scope.row.currency = p.code
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "单价", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDetailMode,
                                    size: "small",
                                    placeholder: "请输入"
                                  },
                                  on: {
                                    input: function(val) {
                                      return _vm.onUnitPriceInput(
                                        scope.row,
                                        val
                                      )
                                    }
                                  },
                                  model: {
                                    value: scope.row.unitPrice,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "unitPrice", $$v)
                                    },
                                    expression: "scope.row.unitPrice"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      !_vm.isDetailMode
                        ? _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "80",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          type: "danger",
                                          icon: "el-icon-delete",
                                          circle: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteJobRow(
                                              scope.$index
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4098416515
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              !_vm.isDetailMode
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onSave()
                        }
                      }
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.onCancel()
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }